import script from "./ResumeContactDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResumeContactDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ResumeContactDetails.vue?vue&type=style&index=0&id=12fb699a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12fb699a"]])

export default __exports__